module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/hero_mob-b9129a5d6fdaf94038d13293da8fbdd9.jpg";